<div
  class="observation animal-group__child spacing--padding-all spacing--margin-all"
  data-test="observation"
>
  <form [formGroup]="form" (ngSubmit)="save()">
    <div class="flex--column">
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'animal-group.observation.start-weight' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.01"
          placeholder="{{ 'animal-group.observation.start-weight' | translate }}"
          formControlName="startWeight"
          data-test="observation__animal-group-start-weight"
        />
      </mat-form-field>
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'animal-group.observation.realized-growth' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="1"
          placeholder="{{ 'animal-group.observation.realized-growth' | translate }}"
          formControlName="realizedGrowth"
          data-test="observation__animal-group-realized-growth"
        />
      </mat-form-field>
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'animal-group.observation.realized-feedintake' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.01"
          placeholder="{{ 'animal-group.observation.realized-feedintake' | translate }}"
          formControlName="realizedFeedintake"
          data-test="observation__animal-group-realized-feedintake"
        />
      </mat-form-field>
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'animal-group.observation.realized-feedconversion' | translate }}</mat-label>
        <input
          style="color: black"
          matInput
          placeholder="{{ 'animal-group.observation.realized-feedconversion' | translate }}"
          formControlName="realizedFeedconversion"
          data-test="observation__animal-group-realized-feedconversion"
        />
      </mat-form-field>

      <div class="spacing--margin-top mat-button-row">
        <button
          type="submit"
          mat-flat-button
          class="flex__child"
          color="primary"
          data-test="observation__save"
        >
          {{ 'save' | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
